import { combineReducers } from 'redux'
import counter from './counter'
import users from './users'
import admin from './admin'
import dates from './dates'
import classes from './classes'
import bookedit from './bookedit'
import bookings from './bookings'
import giftcards from './giftcards'
import useractions from './useractions'

export default combineReducers({
  users,
  counter,
  admin,
  bookedit,
  bookings,
  classes,
  dates,
  giftcards,
  useractions
})
